import type { ReactNode } from 'react';

interface ContentListPageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  /** When false, omit the h1 even if title is set (non-panel layouts only). */
  showTitle?: boolean;
}

export function ContentListPageHeader({
  title,
  subtitle,
  showTitle = true,
}: ContentListPageHeaderProps) {
  if (!showTitle && !subtitle) return null;

  return (
    <div className="flex flex-col gap-6">
      {showTitle && title ? <h1 className="text-h2 text-text-primary">{title}</h1> : null}
      {subtitle}
    </div>
  );
}
